import { UrlConstants } from "../url.constants";
export class ApiEditableSurvey123Constants {
    static URL = UrlConstants.API_V2 + "EditableSurvey";
    static FUNCTION_DELETE_ALL_SURVEY_123S = "DeleteAllSurvey123s";
    static FUNCTION_GET_CREATE_EDITABLE_SURVEY_123S = "GetAndCreateEditableSurvey";
}
